export function taraWritingOneResponseMessage(promptCount) {
  const n = Number(promptCount);
  if (!Number.isFinite(n) || n <= 1) {
    return 'You must only respond to this Writing Task prompt.';
  }
  if (n === 3) {
    return 'You must only respond to ONE question. Leave the other two blank.';
  }
  return `You must only respond to ONE question. Leave the other ${n - 1} blank.`;
}

export function buildTaraWritingPracticeInstructionBody({
  promptCount,
  maxWords,
  formatG = false,
} = {}) {
  const n = Number(promptCount) > 0 ? Number(promptCount) : 1;
  const cap = Number(maxWords) > 0 ? Number(maxWords) : 750;
  if (n === 1) {
    return [{
      text: `This Writing Task practice has one prompt. Write a response of up to ${cap} words.`,
    }];
  }
  if (n === 3 && formatG) {
    return [{
      text: `This Writing Task has three questions. Answer ONE. Leave the other two blank. Write up to ${cap} words.`,
    }];
  }
  return [{
    text: `This Writing Task practice has ${n} prompts. Write a response of up to ${cap} words.`,
  }];
}
